var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { PlacementType } from '@amzn/handshake-painter-typescript-client/v1';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Custom hook to fetch product widget data based on ASINs from URL parameters
 */
export const useProductWidget = ({ enabled }) => {
    const [searchParams] = useSearchParams();
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    // Extract ASINs from URL parameters
    const asinsParam = searchParams.get('asins');
    const asins = (asinsParam === null || asinsParam === void 0 ? void 0 : asinsParam.split(',').filter(Boolean)) || [];
    return useQuery({
        queryKey: [
            'getProductWidget',
            asins,
            defaultApiParams.marketplaceId,
            defaultApiParams.xJoinId,
            defaultApiParams.xUserLinked,
        ],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return yield HandshakePainterServiceApiV1.getProductWidget({
                asins,
                placement: PlacementType.CustomersAlsoBought, // Default to "Customers also bought"
                xUserLinked: defaultApiParams.xUserLinked,
                xJoinId: defaultApiParams.xJoinId,
                marketplaceId: defaultApiParams.marketplaceId,
            });
        }),
        enabled: enabled && asins.length >= 3,
    });
};
